// Cores baseadas nas bandeiras do Brasil e Itália
export const colors = {
  // Cores da bandeira do Brasil
  brazil: {
    green: '#009639',      // Verde da bandeira
    yellow: '#FEDD00',     // Amarelo da bandeira
    blue: '#012169',       // Azul do círculo
  },
  
  // Cores da bandeira da Itália
  italy: {
    green: '#009246',      // Verde da bandeira
    white: '#FFFFFF',      // Branco da bandeira
    red: '#CE2B37',        // Vermelho da bandeira
  },
  
  // Cores misturadas e harmonizadas
  primary: {
    green: '#009639',      // Verde do Brasil
    yellow: '#FEDD00',     // Amarelo do Brasil
    blue: '#012169',       // Azul do Brasil
    red: '#CE2B37',        // Vermelho da Itália
    orange: '#FF6B35',     // Laranja (cor principal)
  },
  
  // Cores neutras
  neutral: {
    white: '#FFFFFF',
    lightGray: '#F8F9FA',
    gray: '#6C757D',
    darkGray: '#343A40',
    black: '#000000',
  },
  
  // Cores de fundo
  background: {
    light: '#F8F9FA',
    white: '#FFFFFF',
    dark: '#343A40',
  },
  
  // Cores de texto
  text: {
    primary: '#343A40',
    secondary: '#6C757D',
    light: '#FFFFFF',
    accent: '#FF6B35',
  }
};

export default colors;
